const roles = {
  dealer: 'Dealer',
  provider: 'Provider',
  lender: 'Lender',
  lawyer: 'Lawyer',
  administrator: 'Administrator',
};

export default roles;
